import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface TagProps {
  variant?: 'default' | 'suggested';
}

export const Tag = styled.span<TagProps>`
  display: inline-block;
  padding: 2px 8px;
  margin-left: 8px;

  background-color: ${({ variant }) =>
    variant === 'suggested'
      ? `${colors.primary}1f`
      : colors.surfaceContainerHighest};
  color: ${({ variant }) =>
    variant === 'suggested' ? colors.primary : colors.onSurfaceVariant};
  border-radius: ${radius.full};

  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  vertical-align: middle;
`;

export const DisabledField = styled.div`
  opacity: 0.5;
  pointer-events: none;
`;
